import PopupContainer from '../../../common/components/PopupContainer';
import CustomButton from '../../../common/components/CustomButton';

export default function RecipientNameLegalConfirmPopup({
  recipientName,
  onCancel,
  onConfirm,
} : {
  recipientName: string,
  onConfirm: () => void,
  onCancel: () => void,
}) {
  return (
    <PopupContainer title="※確認※">
      <div className="list__body">
        <p>
          「
          {recipientName}
          」はあなたの本名、またはあなたが代表権を持つ法人の正式名称ですか？
          <br />
          <br />
          もしそうでない場合、私文書偽造罪にあたるおそれがございます。
          <br />
          修正する場合は次の画面へ進まずログイン後のメニュー「
          <a href="/artist_works" target="_blank" rel="noreferrer">カラオケ配信の管理</a>
          」より申込者名の修正依頼をし、完了してから再度お手続きください。（
          <a href="https://help.frekul.com/522/" target="_blank" rel="noreferrer">ヘルプ</a>
          ）
        </p>
        <ul>
          <li className="bt">
            <CustomButton type="cancel-split" onClick={() => onCancel()}>戻る</CustomButton>
            <CustomButton type="default-split" onClick={() => onConfirm()}>確認</CustomButton>
          </li>
        </ul>
      </div>
    </PopupContainer>
  );
}
